import ContactDetails from "@/components/layout/ContactDetails";
import TitleBar from "@/components/layout/TitleBar";

export default function HomeHero() {
  return (
    <TitleBar>
      <section className="flex flex-col xl:flex-row xl:items-start justify-around align-top xl:gap-x-24 py-6">

        <h1 className="w-full xl:basis-7/12 mb-6 text-center text-balance text-[calc(var(--text-fluid-h1)*0.8)]">
          Emergency Vehicle Technician Certification Commission, Inc.
        </h1>
        <ContactDetails />
      </section>
    </TitleBar>
  );
}
